import type { QueryKey } from '@tanstack/react-query';
import { getDetails, getTimeline, type TrackingParams } from './tracking.api';
import { QueryApiOptions } from '../../types/types';
import { WithPartial } from '@as-react/common-types';

export const trackingQueryKeys = {
  all: () => ['tracking'] as QueryKey,
  details: ({ hash }: TrackingParams) => [...trackingQueryKeys.all(), 'details', hash] as QueryKey,
  timeline: (hash: TrackingParams) => [...trackingQueryKeys.all(), 'timeline', hash] as QueryKey,
};

export const trackingQueries = (apiOptions: WithPartial<QueryApiOptions, 'defaultRequestParams'>) => ({
  getDetails: (hash: TrackingParams) => ({
    queryKey: trackingQueryKeys.details(hash),
    queryFn: () => getDetails(apiOptions, hash),
  }),
  getTimeline: (hash: TrackingParams) => ({
    queryKey: trackingQueryKeys.timeline(hash),
    queryFn: () => getTimeline(apiOptions, hash),
  }),
});
